import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsInstance, IsOptional, ValidateNested } from 'class-validator';
import { OrderConfigExposeGroup } from '../../order-config/interface';
import { PatchPrepTimeCalculationDailyScheduleDto } from './PatchPrepTimeCalculationDailyScheduleDto';
export class PatchPrepTimeCalculationWeeklyScheduleDto {
}
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationDailyScheduleDto, isArray: true, description: 'Daily schedule' }),
    Type(() => PatchPrepTimeCalculationDailyScheduleDto),
    ValidateNested({ always: true, each: true }),
    IsArray({ always: true }),
    IsInstance(PatchPrepTimeCalculationDailyScheduleDto, { each: true, always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], PatchPrepTimeCalculationWeeklyScheduleDto.prototype, "mon", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationDailyScheduleDto, isArray: true, description: 'Daily schedule' }),
    Type(() => PatchPrepTimeCalculationDailyScheduleDto),
    ValidateNested({ always: true, each: true }),
    IsArray({ always: true }),
    IsOptional({ always: true }),
    IsInstance(PatchPrepTimeCalculationDailyScheduleDto, { each: true, always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], PatchPrepTimeCalculationWeeklyScheduleDto.prototype, "tue", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationDailyScheduleDto, isArray: true, description: 'Daily schedule' }),
    Type(() => PatchPrepTimeCalculationDailyScheduleDto),
    ValidateNested({ always: true, each: true }),
    IsArray({ always: true }),
    IsOptional({ always: true }),
    IsInstance(PatchPrepTimeCalculationDailyScheduleDto, { each: true, always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], PatchPrepTimeCalculationWeeklyScheduleDto.prototype, "wed", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationDailyScheduleDto, isArray: true, description: 'Daily schedule' }),
    Type(() => PatchPrepTimeCalculationDailyScheduleDto),
    ValidateNested({ always: true, each: true }),
    IsArray({ always: true }),
    IsOptional({ always: true }),
    IsInstance(PatchPrepTimeCalculationDailyScheduleDto, { each: true, always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], PatchPrepTimeCalculationWeeklyScheduleDto.prototype, "thu", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationDailyScheduleDto, isArray: true, description: 'Daily schedule' }),
    Type(() => PatchPrepTimeCalculationDailyScheduleDto),
    ValidateNested({ always: true, each: true }),
    IsArray({ always: true }),
    IsOptional({ always: true }),
    IsInstance(PatchPrepTimeCalculationDailyScheduleDto, { each: true, always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], PatchPrepTimeCalculationWeeklyScheduleDto.prototype, "fri", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationDailyScheduleDto, isArray: true, description: 'Daily schedule' }),
    Type(() => PatchPrepTimeCalculationDailyScheduleDto),
    ValidateNested({ always: true, each: true }),
    IsArray({ always: true }),
    IsOptional({ always: true }),
    IsInstance(PatchPrepTimeCalculationDailyScheduleDto, { each: true, always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], PatchPrepTimeCalculationWeeklyScheduleDto.prototype, "sat", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationDailyScheduleDto, isArray: true, description: 'Daily schedule' }),
    Type(() => PatchPrepTimeCalculationDailyScheduleDto),
    ValidateNested({ always: true, each: true }),
    IsArray({ always: true }),
    IsOptional({ always: true }),
    IsInstance(PatchPrepTimeCalculationDailyScheduleDto, { each: true, always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], PatchPrepTimeCalculationWeeklyScheduleDto.prototype, "sun", void 0);
//# sourceMappingURL=PatchPrepTimeCalculationWeeklyScheduleDto.js.map